"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Features = void 0;
const envFeature_1 = require("./envFeature");
const feature_1 = require("./feature");
const partialMatchFeature_1 = require("./partialMatchFeature");
const US_COUNTRY_BU = ['PSTF'];
const FR_COUNTRY_BU = ['FR', 'PM'];
exports.Features = {
    AccountabilityManageableByAllTeamMembers: new feature_1.Feature([...US_COUNTRY_BU]),
    Acquisition: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    AcquisitionCrmAntiSpamRules: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    AcquisitionCrmContactBlock: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    AcquisitionCrmContactFilter: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    AcquisitionNeedActions: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    AcquisitionNeedActionsManualLogging: new feature_1.Feature([...FR_COUNTRY_BU]),
    AgencyFilter: new feature_1.Feature([...FR_COUNTRY_BU]),
    ApplicationReceiptConfirmationPdf: new feature_1.Feature(['IL']),
    ArchivedNeedAutoCloseWithoutMessageSending: new feature_1.Feature([...US_COUNTRY_BU]),
    AutoCloseApplicationWithoutMessageSending: new feature_1.Feature([...US_COUNTRY_BU]),
    Bestt: new feature_1.Feature([...FR_COUNTRY_BU]),
    CashAdvance: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    BackofficeConsoleCvParsing: new feature_1.Feature(['FR']),
    BackofficeConsoleDocumentParsing: new feature_1.Feature(['FR']),
    BackofficeConsoleIziCheck: new feature_1.Feature(['FR']),
    BackofficeNotificationCenter: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    BulkWorkerQualification: new feature_1.Feature([...US_COUNTRY_BU]),
    CET: new feature_1.Feature([...FR_COUNTRY_BU]),
    CETPartialWithdraw: new feature_1.Feature(['PM']),
    CloseApplicationWithoutMessageSending: new feature_1.Feature([...US_COUNTRY_BU]),
    CompanyChildEntities: new feature_1.Feature([...US_COUNTRY_BU]),
    CompanyCodeApeReferenceData: new feature_1.Feature(['IT']),
    CompanyCoefficientSwitch: new feature_1.Feature([...FR_COUNTRY_BU]),
    CompanyCollectiveAgreementDeletion: new feature_1.Feature(['IT']),
    CompanyCommercialAgreements: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    CompanyCVxTab: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    CompanyDefaultPlaceOnCreation: new feature_1.Feature(['IT']),
    CompanyExternalCrm: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    CompanyExternalSync: new feature_1.Feature(['IT']),
    CompanyFinanceAnalytics: new feature_1.Feature(['FR', 'PM']),
    CompanyFinanceState: new feature_1.Feature(['FR']),
    CompanyLunchTickets: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    CompanyMissionCreationForParentEntities: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    CompanyOnFoTsByDefault: new feature_1.Feature([...US_COUNTRY_BU]),
    CompanyOrderSettings: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    CompanyOvertimeManagementReadOnly: new feature_1.Feature([...US_COUNTRY_BU]),
    CompanyParentImmutable: new feature_1.Feature([...US_COUNTRY_BU]),
    CompanyPlaceAddressUnique: new feature_1.Feature([...US_COUNTRY_BU]),
    CompanyPlaceConditionalRequired: new feature_1.Feature([...US_COUNTRY_BU]),
    CompanyPlaceDeletion: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    CompanyPlacePendingDeletion: new feature_1.Feature(['IT']),
    CompanyPrimaryTeamEditable: new envFeature_1.EnvFeature({
        outsideProduction: [...US_COUNTRY_BU, ...FR_COUNTRY_BU, 'IT'],
        inProduction: ['PM', ...US_COUNTRY_BU],
    }),
    CompanyRequiredEquipments: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    CompanyTransportPolicy: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    CompanySingleTeam: new feature_1.Feature([...US_COUNTRY_BU]),
    CompanyTeamFromSquad: new feature_1.Feature(['FR', 'IT']),
    CompanyTeamRequireValid: new feature_1.Feature([...US_COUNTRY_BU]),
    CompanyShippingAddress: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    CompanySpecificDayPolicy: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    CompanyWorkingTimeModulationAgreement: new feature_1.Feature([...FR_COUNTRY_BU]),
    CompanyPlaceAddressStateShortRequired: new feature_1.Feature([...US_COUNTRY_BU]),
    CompensationCode: new feature_1.Feature([...US_COUNTRY_BU]),
    ContingentJobOffer: new feature_1.Feature([...US_COUNTRY_BU]),
    ContractAmendmentDeletion: new feature_1.Feature(['FR']),
    ContractStateForceCreation: new feature_1.Feature([...US_COUNTRY_BU]),
    ContractStateFrozenClientTerms: new feature_1.Feature([...US_COUNTRY_BU]),
    Contracts: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    ContractsPayrollSystem: new feature_1.Feature([...FR_COUNTRY_BU]),
    ContractBulkDownloadDocuments: new feature_1.Feature([...FR_COUNTRY_BU]),
    ContractsDirectHire: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    DirectMessageEmail: new feature_1.Feature([...US_COUNTRY_BU]),
    DocumentParsingRefileMisfiled: new feature_1.Feature([...FR_COUNTRY_BU]),
    DocumentTypeDetection: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    EmailForIndeedRecipientsEnabled: new feature_1.Feature([...US_COUNTRY_BU]),
    EmailTemplateBasedOnWorkerLanguage: new feature_1.Feature([...US_COUNTRY_BU]),
    EmployeePhone: new feature_1.Feature([...US_COUNTRY_BU]),
    ExternalJobOffers: new feature_1.Feature([...US_COUNTRY_BU]),
    ExternalOnboarding: new feature_1.Feature([...US_COUNTRY_BU]),
    FreeApplications: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    HidePayRate: new feature_1.Feature([...US_COUNTRY_BU]),
    HourlyRateChecking: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    InterimCoeffInPercents: new feature_1.Feature([...US_COUNTRY_BU]),
    InvoiceElectronicTransmission: new feature_1.Feature([...FR_COUNTRY_BU]),
    Invoices: new feature_1.Feature([...FR_COUNTRY_BU]),
    InvoiceSettings: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    InterimReason: new feature_1.Feature([...FR_COUNTRY_BU]),
    IziPro: new feature_1.Feature(['FR', 'IT']),
    IziProDefaultContact: new feature_1.Feature(['FR']),
    JobBoardAddressWithPostalCode: new feature_1.Feature([...US_COUNTRY_BU]),
    JobBoardApplyCvRequired: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    JobBoardExternalLinksWithLanguage: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    JobBoardGoogleIndexing: new feature_1.Feature(['FR', 'IT']),
    JobBoardInCountrySearchCategories: new feature_1.Feature([...US_COUNTRY_BU]),
    JobBoardIndexNow: new feature_1.Feature(['FR', 'IT']),
    JobBoardLocationMandatory: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    JobBoardPublishedDateOnPreview: new feature_1.Feature([...US_COUNTRY_BU]),
    JobBoardSEO: new feature_1.Feature(['FR', 'IT']),
    JobBoardTermsOfServiceAvailable: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    JobsDownloadAppIfNoJobOffers: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    JobOfferAddressWithState: new feature_1.Feature([...US_COUNTRY_BU]),
    JobOfferApplyWithState: new feature_1.Feature([...US_COUNTRY_BU]),
    JobOfferAppToDownload: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    JobOfferComplianceCheck: new feature_1.Feature([...FR_COUNTRY_BU]),
    JobOfferDefaultIntroductionField: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    JobOfferDefaultText: new feature_1.Feature([...FR_COUNTRY_BU, ...US_COUNTRY_BU]),
    JobOfferNeedStateMatch: new feature_1.Feature([...US_COUNTRY_BU]),
    JobOfferWorkRatesExpected: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    LegalCompanyIdentification: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    LocationWithSubpremise: new feature_1.Feature([...US_COUNTRY_BU]),
    MedicalVisit: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    MedicalVisitsEngine: new envFeature_1.EnvFeature({ outsideProduction: FR_COUNTRY_BU, inProduction: [] }),
    MinCoeffChecking: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    MissionArbitraryPlace: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    MissionBillRate: new feature_1.Feature([...US_COUNTRY_BU]),
    MissionConstraint: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    MissionDifficultyFactors: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    MissionFlatRatePlacement: new feature_1.Feature([...FR_COUNTRY_BU]),
    MissionJobLevel: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    MissionJobPosition: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    MissionLowSalaryRangePlacement: new feature_1.Feature([...FR_COUNTRY_BU, ...US_COUNTRY_BU]),
    MissionManagementStatus: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    MissionMonthlyBonusPlacement: new feature_1.Feature([...FR_COUNTRY_BU]),
    MissionOpsComment: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    MissionPlacementHourlyRateNoticeTime: new feature_1.Feature([...FR_COUNTRY_BU]),
    MissionPlanningType: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    MissionExtension: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    MissionSchedulePrecision: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    MissionRiskIndicator: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    MissionRiskFactors: new feature_1.Feature([...FR_COUNTRY_BU]),
    MissionSalaryComment: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    MissionTasksSupportEmoji: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    MissionTabTarget: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    MonitoringCustomRateColumn: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    MonitoringCV3Comment: new feature_1.Feature(['IT']),
    MonitoringCV6: new feature_1.Feature([...FR_COUNTRY_BU, 'IT', ...US_COUNTRY_BU]),
    MonitoringProfilePicture: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    NanpPhoneNumberSearch: new feature_1.Feature([...US_COUNTRY_BU]),
    NeedLocationStateShortRequired: new feature_1.Feature([...US_COUNTRY_BU]),
    NeedMissionEndDateRequired: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    NeedListAsDefaultPage: new feature_1.Feature(['PSTF']),
    IDnowDocumentVerification: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    NeedOnParentCompany: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    NeedPlannedRenewals: new feature_1.Feature([...FR_COUNTRY_BU]),
    NeedTeamRequireValid: new feature_1.Feature([...US_COUNTRY_BU]),
    NightRangeHours: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    OcrIdentityRefileMisfiled: new feature_1.Feature([...FR_COUNTRY_BU]),
    ParentMissionCarRequired: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    ParentMissionDraftBusinessStatuses: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    ParentMissionMaxLocationDistance: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    ParentMissionOfferType: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    ParentMissionReferenceNeedRequired: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    ParentMissionQualifReportRowNavigation: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    ParentMissionRequiredBanner: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    ParentMissionRequiredEquipments: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    PaymentOptions: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    PlaceWorkerOnMultipleOrders: new feature_1.Feature([...FR_COUNTRY_BU]),
    PreselectedInterested: new feature_1.Feature([...US_COUNTRY_BU]),
    PaymentSettings: new feature_1.Feature([...FR_COUNTRY_BU]),
    PayrollSystemPlaces: new feature_1.Feature([...FR_COUNTRY_BU]),
    Pooler: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    QualifPageWorkerExperienceEditable: new feature_1.Feature([...US_COUNTRY_BU]),
    QualifPageWorkerProfileEditable: new feature_1.Feature([...US_COUNTRY_BU]),
    Reimbursement: new feature_1.Feature([...FR_COUNTRY_BU]),
    RubricApplicationDays: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    RubricChildCompanyOnly: new feature_1.Feature([...US_COUNTRY_BU]),
    RubricDefaultOnCompanyCreation: new feature_1.Feature([...US_COUNTRY_BU]),
    RubricExpirationDateField: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    RubricMissionTypeField: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    RubricNature: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    RubricParentMissionRequired: new feature_1.Feature([...US_COUNTRY_BU]),
    RubricTimesheetOnly: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    RubricValidityDateField: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    ContactWorkerJobDetailsDefaultText: new feature_1.Feature([...US_COUNTRY_BU]),
    ShiftEndDateRequired: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    ShiftResponsible: new feature_1.Feature([...US_COUNTRY_BU]),
    ShiftTeam: new feature_1.Feature([...US_COUNTRY_BU]),
    ShiftTransitionExternalSyncGuard: new feature_1.Feature([...US_COUNTRY_BU]),
    SmicChecking: new feature_1.Feature([...FR_COUNTRY_BU]),
    StartSheet: new feature_1.Feature([...US_COUNTRY_BU]),
    StartSheetAdditionalRequirements: new feature_1.Feature(['IL']),
    StartSheetPreview: new envFeature_1.EnvFeature({ outsideProduction: US_COUNTRY_BU, inProduction: [] }),
    UserProfileSignature: new feature_1.Feature([...US_COUNTRY_BU]),
    TeamAddressRequired: new feature_1.Feature([...US_COUNTRY_BU]),
    TeamAnalyticsCodeShared: new feature_1.Feature(['PM']),
    TeamInfo: new feature_1.Feature(['PM', ...US_COUNTRY_BU]),
    TeamPhoneRequired: new feature_1.Feature([...US_COUNTRY_BU]),
    TeamSignerRequired: new partialMatchFeature_1.PartialMatchFeature([{ stateShort: 'IL' }]),
    TeamSignerRequiredCheckEnabled: new feature_1.Feature([...US_COUNTRY_BU]),
    TimesheetDeclarativeOptions: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    TimesheetReminderFrequency: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    TimesheetImportByFile: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    TimesheetPlatformAndDeclarative: new feature_1.Feature([...FR_COUNTRY_BU, ...US_COUNTRY_BU]),
    TimesheetHoursOutsideBounds: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    TimesheetSynchronization: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    TimesheetParserStudio: new feature_1.Feature([...FR_COUNTRY_BU]),
    TimesheetReminders: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    TimesheetFoTsRubricsEditable: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    TimesheetShift: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    VerifPrefEmailReplyTo: new feature_1.Feature(['PM']),
    WorkerAccountDeletionRetentionPolicy: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerAddressStateShortRequired: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerAddressProofCompliance: new feature_1.Feature([...FR_COUNTRY_BU]),
    WorkerAddressProofParsing: new feature_1.Feature([...FR_COUNTRY_BU]),
    WorkerApplicationWithPreferences: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerAvionteStatus: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerBankAccountCannotBeRemoved: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerBankAccountPartialFulfilment: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerCdii: new feature_1.Feature([...FR_COUNTRY_BU]),
    WorkerDisabilityPreferences: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerEquipments: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerExperienceDescription: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerExperienceStartDateOptional: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerSearchIndexIncludeExperience: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerExperienceJobTitleHideDefaultOptions: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerGenderAndNameAreEditable: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerIdentityDocument: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerSecurityDocumentSigning: new feature_1.Feature(['FR']),
    WorkerSecurityTrainingJobMapping: new feature_1.Feature([...FR_COUNTRY_BU]),
    WorkerEmergencyContactMandatory: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerInformationSSN: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerUseIbanInApp: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerNationality: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerNoteType: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerPreferencesAddressWithState: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerRace: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerVeteranStatus: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerDobReadByAll: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerGenderReadByAll: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerRqthReadByAll: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerBehaviorWarnings: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerDrivingLicense: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerActivityHistory: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerHistory: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerLanguageLevel: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerLocationCarpooling: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerLogAs: new feature_1.Feature([...FR_COUNTRY_BU, ...US_COUNTRY_BU]),
    WorkerNoteEditOwned: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerOps: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerPaymentAccountType: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerPhoneNumberRequired: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerPicture: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerPlaceOfBirth: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerForeignStudent: new feature_1.Feature([...FR_COUNTRY_BU]),
    WorkerPreferencesIsStudent: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerPreselectionBlocking: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerTransportationSelection: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerBankName: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerMarketingCampaignTracking: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerCertificatesCheck: new feature_1.Feature([...FR_COUNTRY_BU, ...US_COUNTRY_BU]),
    WorkerContractInApp: new feature_1.Feature([...FR_COUNTRY_BU]),
    WorkerCreationPrimaryPaymentFields: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerDocumentExpiringSoon: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerDocumentsForHealthcareCheck: new feature_1.Feature(['FR', 'PM']),
    WorkerMedicalVisit: new feature_1.Feature([...FR_COUNTRY_BU]),
    WorkerReferral: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerSecurityTrainings: new feature_1.Feature([...FR_COUNTRY_BU, ...US_COUNTRY_BU]),
    WorkerQuizScoreEdit: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerQuizScoreAsPercentage: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerDobEditable: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerDisability: new feature_1.Feature(['IT']),
    WorkerSsnDeletable: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerSsnEditable: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerRPPS: new feature_1.Feature(['PM']),
    ShiftReasonAnticipatedCustomerStopRestriction: new feature_1.Feature([...FR_COUNTRY_BU]),
    ShiftDetailedReasonsFilter: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    ShiftEndDateFallbackToMissionEndDate: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    ShiftEffectiveEndDateAsEndDate: new feature_1.Feature([...US_COUNTRY_BU]),
    ShiftCancelledEffectiveEndDate: new feature_1.Feature([...US_COUNTRY_BU]),
    ShiftBulkEndReasonModal: new feature_1.Feature([...US_COUNTRY_BU]),
    ShiftComplianceManualReminderCooldown: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    ComplianceInformativeViolationsConfirmation: new feature_1.Feature([...US_COUNTRY_BU]),
    ShiftReasonFieldsHiddenOutsideCV5: new feature_1.Feature([...US_COUNTRY_BU]),
    ShiftWorkerCancelApplicationAppStatus: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    TemporaryMissionWithoutEndDate: new feature_1.Feature([...US_COUNTRY_BU]),
    ShiftRenewed: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    ShiftAnnualSalary: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    ShiftTimeOffWork: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerIziCVExperienceEndDateInference: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerIziCVDropExperiencesWithoutEndDate: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerIziCVDropExperiencesWithoutStartOrEndDate: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerIziCVExperienceDropOtherJobDetail: new feature_1.Feature([...FR_COUNTRY_BU, 'IT']),
    WorkerIziCVDeduplicateIncludeCompany: new feature_1.Feature([...US_COUNTRY_BU]),
    QuickSearchWorkerFullNameFirstnameFirst: new feature_1.Feature([...US_COUNTRY_BU]),
    WorkerIziStopJiraTicket: new feature_1.Feature(['FR']),
};
